import {
  CLEAR_FUEL_REPORT_DATA,
  CREATE_FUEL_SUCCESS,
  FETCH_ASSET_FILTER_SUCCESS, FETCH_ASSET_FUEL_SUCCESS,
  FETCH_FUEL_FILTER_DATA_SUCCESS, FETCH_FUEL_MILEAGE_REPORT_DATA_SUCCESS,
  FETCH_FUEL_REFUEL_REPORT_DATA_SUCCESS,
  FETCH_FUEL_REPORT_DATA_SUCCESS,
  FETCH_FUEL_STATUS_DATE_SUCCESS,
  FETCH_FUEL_SUCCESS, FETCH_FUEL_SUMMERY_REPORT_DATA_SUCCESS,
  FETCH_BOWSER_TRANSACTION_REPORT_DATA_SUCCESS,
  FETCH_BOWSER_REPORT_DATA_SUCCESS,
  FETCH_MOTORABLE_ASSET_SUCCESS,
  GET_FUEL_SUCCESS,
  SAVE_FUEL_QUERY,
} from "../../constants/ActionTypes";
import { message } from "antd";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  reports: [],
  mileage_report_data: [],
  summery_report_data: [],
  refuel_report_data: [],
  bowser_transaction_data: [],
  bowser_report_data: {},
  assets: [],
  filters: {},
  statusDates: [],
  assetFuels: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_FUEL_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_FUEL_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_FUEL_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_FUEL_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_ASSET_FUEL_SUCCESS: {
      return {
        ...state,
        assetFuels: action.data,
      }
    }

    case FETCH_FUEL_REPORT_DATA_SUCCESS: {
      if (action.data.length === 0) {
        message.error("No data found for given query, please try with different parameters!");
      }
      return {
        ...state,
        reports: action.data,
      }
    }

    case FETCH_FUEL_MILEAGE_REPORT_DATA_SUCCESS: {
      return {
        ...state,
        mileage_report_data: action.data,
      }
    }

    case FETCH_FUEL_SUMMERY_REPORT_DATA_SUCCESS: {
      return {
        ...state,
        summery_report_data: action.data,
      }
    }

    case FETCH_FUEL_REFUEL_REPORT_DATA_SUCCESS: {
      return {
        ...state,
        refuel_report_data: action.data,
      }
    }

    case FETCH_BOWSER_TRANSACTION_REPORT_DATA_SUCCESS: {
      return {
        ...state,
        bowser_transaction_data: { data: action.data, count: action.count },
      }
    }

    case FETCH_BOWSER_REPORT_DATA_SUCCESS: {
      return {
        ...state,
        bowser_report_data: action.data,
      }
    }

    case CLEAR_FUEL_REPORT_DATA: {
      return {
        ...state,
        reports: [],
      }
    }

    case FETCH_ASSET_FILTER_SUCCESS: {
      return {
        ...state,
        assets: action.assets,
      }
    }

    case FETCH_MOTORABLE_ASSET_SUCCESS: {
      return {
        ...state,
        assets: action.data,
      }
    }

    case FETCH_FUEL_FILTER_DATA_SUCCESS: {
      return {
        ...state,
        filters: action.data,
      }
    }
    case FETCH_FUEL_STATUS_DATE_SUCCESS: {
      return {
        ...state,
        statusDates: action.data,
      }
    }
    default:
      return state;
  }
}
